var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgHeartTag = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 80",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M66.45 23.34c-4.48-4.59-11.64-4.49-15.99.23l-2.54 2.75-2.61-2.68c-2.2-2.25-5.04-3.37-7.88-3.37s-5.9 1.21-8.11 3.61c-4.35 4.72-4.25 12.26.22 16.85l2.61 2.68 16.21 16.62 15.77-17.09 2.54-2.75c2.14-2.31 3.2-5.31 3.2-8.31s-1.14-6.21-3.42-8.54Zm-32.04 7.92c-1.45 0-2.62-1.17-2.62-2.62s1.17-2.62 2.62-2.62 2.62 1.17 2.62 2.62-1.17 2.62-2.62 2.62Z"
  })));
};
export default SvgHeartTag;